import { Col } from 'react-bootstrap';
import { Field } from 'redux-form';
import { HorizontalFormControl, InfoLabel } from '../../../../../../common/components';
import parseFloatValue from '../../../../../../helpers/parseFloatValue';
import React from 'react';

const LABEL_SIZE = 6;
const FIELD_SIZE = 6;

const GeneralRules = ({ isViewOnly }) => (
  <>
    <Col sm={6}>
      <Field
        name="meta.config.rules.quote_valid_for_days"
        label="Quote Validity (days):"
        labelSize={LABEL_SIZE}
        fieldSize={FIELD_SIZE}
        component={isViewOnly ? InfoLabel : HorizontalFormControl}
        parse={parseFloatValue}
      />
    </Col>
    <Col sm={6}>
      <Field
        name="meta.config.rules.cancellation_period"
        label="Cancellation Period:"
        labelSize={LABEL_SIZE}
        fieldSize={FIELD_SIZE}
        component={isViewOnly ? InfoLabel : HorizontalFormControl}
        parse={parseFloatValue}
      />
    </Col>
    <Col sm={6}>
      <Field
        name="meta.config.rules.owner_backdate_cover"
        label="Back Date Cover Days:"
        labelSize={LABEL_SIZE}
        fieldSize={FIELD_SIZE}
        component={isViewOnly ? InfoLabel : HorizontalFormControl}
        parse={parseFloatValue}
      />
    </Col>
    <Col sm={6}>
      <Field
        name="meta.config.rules.advance_days"
        label="Advance Days:"
        labelSize={LABEL_SIZE}
        fieldSize={FIELD_SIZE}
        component={isViewOnly ? InfoLabel : HorizontalFormControl}
        parse={parseFloatValue}
      />
    </Col>
  </>
);
export default GeneralRules;
